import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import {
  baseChangeEventFormConfig,
  BaseChangeEventFormInput,
  baseChangeEventMapToForm,
} from "src/routes/projects/change-events/guided/baseChangeEventForm";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import { VersionUpdateStep } from "src/routes/projects/change-events/guided/workflows/configurationTrueUp/1.VersionUpdateStep";
import { reviewStep } from "src/routes/projects/change-events/guided/workflows/sharedSteps/sharedSteps";
import { useGuidedChangeEventActions } from "src/routes/projects/change-events/guided/workflows/sharedSteps/useGuidedChangeEventActions";
import { useReviewStepActions } from "src/routes/projects/change-events/guided/workflows/sharedSteps/useReviewStepActions";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";

export const configurationTrueUpWorkflow = defineWorkflow<BaseChangeEventFormInput>({
  workflow: ChangeEventWorkflow.ConfigurationTrueUp,
  formConfig: baseChangeEventFormConfig,
  // Create change event upfront since this workflow doesn't have a user selected target config
  // and instead it's generated on the backend from the latest promoted Product Offering version.
  beforeStart: async ({ projectId: structureId, input, save }) => {
    const result = await save({ variables: { structureId, input: { ...input, configChange: {} } } });
    return { changeEventId: result.data!.saveChangeEvent.changeEvent.id };
  },
  mapToForm: baseChangeEventMapToForm,
  steps: [
    {
      value: GuidedChangeEventStep.VersionUpdate,
      label: "Version Update",
      isComplete: () => true,
      render: (form) => <VersionUpdateStep formState={form} />,
    },
    {
      value: GuidedChangeEventStep.DiscontinuedOptions,
      label: "Discontinued Options",
      isComplete: () => true,
      render: () => <></>,
    },
    reviewStep(),
  ],
  useActions: (args) => {
    const { saveChangeEvent } = useGuidedChangeEventActions(args);
    const { submit } = useReviewStepActions(args);
    return {
      onSubmit: submit,
      onContinue: { [GuidedChangeEventStep.DiscontinuedOptions]: saveChangeEvent },
      onSaveAndExit: () => saveChangeEvent({ andExit: true }),
    };
  },
});
